<p
    class="post__block post__header"
    :class="classObj"
    v-html="htmlTextWithTargetBlank"
>
</p>
